// extracted by mini-css-extract-plugin
module.exports = {"productList":"product_list_productList__2hJPJ","rowHeader":"product_list_rowHeader__3RHgr"};